import Swal from 'sweetalert2'
import {useNavigate, useParams} from 'react-router-dom'
import React, {useState} from 'react'
import {
  IPricingTable,
  pricingTableInitValues as initialValues,
} from '../../models/PricingTableModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Calendar} from 'primereact/calendar'
import moment from 'moment'
import {insertDataTime} from '../../../../../../util/insertDataTime'

const API_URL = process.env.REACT_APP_API_URL || 'api'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const PricingTableSchema = Yup.object().shape({
  // id: Yup.string().required('Campo obrigatório'),
  //name: Yup.string().required('Campo obrigatório'),
  // unit_measure: Yup.string().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormPricingTableAdd: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const {uuid} = useParams()
  const [start_dateD, setStart_dateD] = useState<Date | undefined>(undefined)
  const [end_dateD, setEnd_dateD] = useState<Date | undefined>(undefined)

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IPricingTable>({
    initialValues,
    validationSchema: PricingTableSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(API_URL + '/sga/v1/issue_organs/' + uuid + '/pricing_tables/', values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PRICING.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate(`/editissueorgans/${uuid}`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PRICING.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })
        navigate(`/editissueorgans/${uuid}`)
        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  const setConvertDate = (e: any, typeDate: 'start_date' | 'end_date') => {
    let DateFormate: any
    switch (typeDate) {
      case 'start_date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setStart_dateD(e)
        formik.setFieldValue('start_date', DateFormate)
        break
      }
      case 'end_date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
        setEnd_dateD(e)
        formik.setFieldValue('end_date', DateFormate)
        break
      }
    }
  }

  insertDataTime()
  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'PRICING.NEW_PRICING_TABLE'})}
      </PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO DESCRIÇÃO ----------------------*/}
            <div className='row'>
              <div className='col-lg-6'>
                <label className='col-form-label required fw-bold'>
                  {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
                </label>
                <Calendar
                  value={start_dateD}
                  onChange={(e: any) => setConvertDate(e.value, 'start_date')}
                  selectionMode='single'
                  inputClassName='form-control-calendar form-control form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                />
              </div>
              <div className='col-lg-6'>
                <label className='col-form-label required fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_DATE_COMPLETION'})}
                </label>
                <Calendar
                  value={end_dateD}
                  onChange={(e: any) => setConvertDate(e.value, 'end_date')}
                  selectionMode='single'
                  inputClassName='form-control-calendar form-control form-control-solid  ps-6 fw-bold border-white'
                  style={{
                    width: '100%',
                  }}
                  dateFormat='dd/mm/yy'
                  placeholder='dd/mm/aaaa'
                  showButtonBar
                />
              </div>
            </div>

            <Input3
              title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              {...formik.getFieldProps('description')}
              type={'textarea'}
            />
            {/* FIM DESCRIÇÃO ------------------------------*/}
            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormPricingTableAdd}
